import {Button, useLocalStorage} from 'platform/components';

import {browserStorageKey} from '@dms/config';

import {getFixedTranslation} from '../../utils/getFixedTranslation';

export function PerformanceToggle() {
  const [isPerformanceTrackingEnabled, setIsPerformanceTrackingEnabled] = useLocalStorage<boolean>(
    browserStorageKey.PERFORMANCE_TRACKING_ENABLED,
    false
  );

  const handleTogglePerformanceTracking = () => {
    setIsPerformanceTrackingEnabled(!isPerformanceTrackingEnabled);
  };

  return (
    <Button
      title={getFixedTranslation('page.settings.labels.performancePanel')}
      onClick={handleTogglePerformanceTracking}
      data-testid="layout-header-devSettings-performancePanel"
      variant={isPerformanceTrackingEnabled ? 'danger' : 'secondary'}
      leftIcon="action/trending_up"
    />
  );
}
